import { STATE_CACHE_NAME } from '@common/Core/constants/cache';
import { get, post, del } from '@common/Http';
import { get as getCookie, set as setCookie } from '@helpers/cookie';
import { saveState } from '@helpers/localStorage';
import { handleVisitorCookieFetch } from '@helpers/visitor';
import { API_CUSTOMER_DEALS_LIST } from '@routes';
import {
    SET_DEALS_ACTIVE,
    SET_CURRENT_DEALS,
    SET_DEALS_TOGGLE
} from './constants';

export const setCurrentDeals = payload => ({
    type: SET_CURRENT_DEALS,
    payload
});

export const setDealsActivated = payload => ({
    type: SET_DEALS_ACTIVE,
    payload
});

export const setDealsToggle = payload => ({
    type: SET_DEALS_TOGGLE,
    payload
});

const updateSession = deals => async (dispatch) => {
    await dispatch(setDealsActivated(deals));
    const stateCookie = getCookie(STATE_CACHE_NAME);
    const stateCookieParsed = stateCookie ? JSON.parse(stateCookie) : { activateDeals: { activated: [] } };

    if (!stateCookieParsed.activateDeals) {
        stateCookieParsed.activateDeals = {};
    }

    stateCookieParsed.activateDeals.activated = deals;

    setCookie(STATE_CACHE_NAME, JSON.stringify(stateCookieParsed));
    saveState('mdv_active_deals', '1');
};

export const getDealsActivated = (data = null) => async (dispatch) => {
    try {
        await handleVisitorCookieFetch(); // we have to make sure visitor is fetched before calling deals list
    } catch (error) {}

    try {
        const response = await get(API_CUSTOMER_DEALS_LIST, data);

        dispatch(updateSession(response));
    } catch (error) {}

    return null;
};

export const toggleDealsActivated = () => (dispatch, getState) => {
    const { activated = [], deals = [] } = getState().activateDeals || {};
    const isAlreadyActivated = activated.length > 0;
    const method = !isAlreadyActivated ? post : del;

    dispatch(updateSession(isAlreadyActivated ? [] : deals.map(deal => deal.id)));

    return method(API_CUSTOMER_DEALS_LIST).then(() => dispatch(setDealsToggle(true)));
};
